<div class="h-100">
  <app-color-switcher *ngIf="isMultiColorActive"></app-color-switcher>
  <!-- <app-timeline-panel></app-timeline-panel> -->
  <report-page></report-page>
  <ngx-ui-loader></ngx-ui-loader>
  <router-outlet></router-outlet>
</div>


